"use client";

import LeftArrowIcon from "@/helpers/svg/leftArrowIcon.svg";
import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "@mui/material";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/scss";
import "swiper/scss/autoplay";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
import "swiper/scss/virtual";
import EffectCarousel from "@/styles/swiper-carousel/dist/effect-carousel.esm.js";
import "@/styles/swiper-carousel/dist/effect-carousel.scss";
import _, { shuffle } from "lodash";
import { Swiper, SwiperSlide } from "swiper/react";
import Link from "next/link";
import { tagsGuide } from "../content/tag";
import NextPlayGuideHelper from "@/helpers/nextPlayGuideHelper";

import ResponsiveImage from "../elements/ResponsiveImage";

const TurkiLar = ({
  items,
  categoryKey,
  preserveOrder = false,
  nextPlayGuide = null,
}) => {
  const lgDesktop = useMediaQuery("(min-width:1280px)");
  const [_items, setItems] = useState(items);
  const _isShuffled = useRef(false);

  useEffect(() => {
    if (preserveOrder) {
      setItems(items);
      _isShuffled.current = false;
      return;
    }

    if (!_isShuffled.current && items?.length > 0) {
      setItems(shuffle(items));
      _isShuffled.current = true;
    }
  }, [items, preserveOrder]);

  const swiperProps = {
    id: "turkylar-swiper",
    modules: [Pagination, EffectCarousel, Navigation, Autoplay],
    className: "swiper-carousel",
    effect: "carousel",
    initialSlide: parseInt(items?.length / 2),
    slidesPerView: "auto",
    loopAdditionalSlides: 3,
    centerInsufficientSlides: true,
    grabCursor: true,
    loop: true,
    spaceBetween: 60,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
  };

  return (
    <div className="h-full w-full">
      <div
        className={`border-t-1 border-b-1 border-solid border-[#432f2f] overflow-x-hidden 
          ${lgDesktop && "turki-gr-border"
          } text-primary-white !pt-0 flex flex-col items-center !bg-[#0F0B0B]`}
      >
        <Link href={"/category/" + categoryKey}>
          <div className="flex justify-center turkilar-box pl-5 pr-6 py-4 items-center border-1 border-solid border-[#432F2F] mb-4 rounded-b-3xl">
            <span className="text-lg sm:text-xl md:text-2xl font-medium ml-2">
              ترﮐﮯلَر
            </span>
            <LeftArrowIcon />
          </div>
        </Link>
        <div className="pt-3 pb-0 w-full relative">
          <Swiper {...swiperProps}>
            {_items?.map(({ content, sliderType }, index) => {
              const { contentPhotos, slug, kind, tags } = content;
              const hasTurkishReport = tags?.some(
                (tagLabel) => tagsGuide[tagLabel] === "TURKISH_REPORT"
              );
              const hasTurkishNative = tags?.some(
                (tagLabel) => tagsGuide[tagLabel] === "TURKISH_NATIVE"
              );
              const badge = hasTurkishReport
                ? { src: "/tags/gozaresh-large.svg", alt: "گزارش ترکی" }
                : hasTurkishNative
                  ? { src: "/tags/exclusive-dubbed.svg", alt: "ترکی دیلینده" }
                  : null;
              return (
                <SwiperSlide
                  key={"turkylar" + sliderType?.toString() + index.toString()}
                  className="bg-tansparent aspect-[45/25] max-w-[600px] px-3"
                >
                  <Link
                    href={NextPlayGuideHelper.addNextPlayGuideToUrl(
                      `/${kind}/${slug}`,
                      kind === "music" ? nextPlayGuide : null
                    )}
                  >
                    <div className="rounded-xl overflow-hidden flex justify-center items-center relative z-10">
                      {badge && (
                        <div className="absolute top-1 right-4 z-50">
                          <img
                            className="mb-5"
                            loading="eager"
                            width={120}
                            src={badge.src}
                            alt={badge.alt}
                          />
                        </div>
                      )}
                      <ResponsiveImage className=" w-[95%] mx-auto rounded-[10px] aspect-[45/25]"
                        contentPhotos={contentPhotos} imageType={"infinitySliderCover"} alt={content.title} />
                    </div>
                  </Link>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        {/* <div className="flex w-full justify-center ">
          <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div>
        </div> */}
      </div>
    </div>
  );
};

export default TurkiLar;
